import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic } from '../../theme/tokens';

export { Badge, IconWrapper } from '../../styles/nav.styles';

export const Bar = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  bottom: var(--keyboard-inset-bottom, 0px);
  left: 0;
  right: 0;
  z-index: 102;
  background: ${colors.white};
  border-top: 1px solid ${semantic.border.default};
  padding: 8px 0 calc(8px + env(safe-area-inset-bottom, 0px));
  height: auto;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: none;
  }
`;

export const TabItem = styled.button<{ $active?: boolean }>`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 4px 12px;
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ $active }) => ($active ? semantic.text.primary : colors.sectionTitle)};
  transition: color 0.15s ease;

  &:hover {
    color: ${semantic.text.primary};
  }
`;

export const TabLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.medium};
`;
